<template lang="pug">
v-row
    v-col
        strong {{ label }}
    v-col.text-right
        v-spacer
        slot
</template>

<script lang="ts">
import { defineComponent } from 'vue';

export default defineComponent({
    props: {
        label: {
            type: String,
            required: true,
        },
    },
});
</script>
